import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);


export default class{

    constructor( options ) {
        this.defaults = {
        	$el: false,
        	sticky: true
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'module-anchor-menu';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;

		if ( this.$el.length > 0 ){
			this.init();
		}
    }

    init(){
    	//console.log( 'init: ' + this.namespace );
    	
    	//-------------------- init menu ------------------------------------------//

    	// desktop
    	this.$lis 		= this.$el.find( '.anchor-menu.hide-for-mobile li' );
    	this.$lis.each( ( i, el )=>{
    		$(el).attr( 'data-index', i );
    		if ( $(el).hasClass( 'current-menu-item' ) ){
    			this.index = i;
    		}
    	});

    	// mobile
    	this.$lis_m 		= this.$el.find( '.anchor-menu.show-for-mobile li' );
    	this.$lis_m.each( ( i, el )=>{
    		$(el).attr( 'data-index', i );
    	});

    	//-------------------- init sections ------------------------------------------//
    	this.$sections 		= this.$el.find( '.anchor-sections .anchor-section' );
    	this.$sections.each( ( i, el )=>{
    		$(el).attr( 'data-index', i );
    	});

    	this.addEvents( true );

    	this.setIndex(0);

    	this.checkHash();

	}

	//---------------------------------------- EVENTS ---------------------------------------//
	addEvents( b ){
		if ( b ){
			this.$lis.find( 'a' ).on( 'click', (e) => this.onSelectMenu(e) );
			this.$lis_m.find( 'a' ).on( 'click', (e) => this.onSelectMenu(e) );
			window.addEventListener( "hashchange", ()=>this.onHashChange() , false );
		}
		else{
			this.$lis.find( 'a' ).off( 'click', (e) => this.onSelectMenu(e) );
			this.$lis_m.find( 'a' ).off( 'click', (e) => this.onSelectMenu(e) );
			window.removeEventListener( "hashchange", ()=>this.onHashChange() , false );
		}
		this.initMenuSticky( b);
		this.initSectionsRevealIndex(b);
	}

	onSelectMenu( e ){
		e.preventDefault();
		let $a = $(e.currentTarget), index = $a.parent().attr( 'data-index' );
		this.scrollToSection( index, 0, $a.parents( '.anchor-menu' ).hasClass( 'show-for-mobile' ) ? 110 : 0 );
 	}

  	scrollToSection( i, delay=0, offsetY=0 ){
  		let $section = this.$sections.eq(i);
  		if ( $section.length > 0 ){
 			gsap.to( $(window), {duration: 0.8, scrollTo: { y : this.$sections.eq(i), offsetY: 60 + offsetY }, delay: delay, ease: 'power.easeOut' });
 		}
 	}
	
 	checkHash(){
 		let hash = document.location.hash, menuItem;

 		if ( hash ){
 			hash = hash.substring(1).replace( /-/g , ' ');

	    	this.$lis.each( ( i, el )=>{

	    		menuItem = $(el).find( 'a' ).text().toLowerCase();
	    		if ( menuItem.indexOf( hash ) !== -1 ){

	    			this.scrollToSection( i, 0.4 );

	    			return true;
	    		}

	    	});
 		}

 		return false;
 	}

 	onHashChange( ){
 		this.checkHash()
 	}

 	setIndex( i ){
 		this.$lis.removeClass( 'current-menu-item' );
 		this.$lis.eq( i ).addClass( 'current-menu-item' );
 		this.$lis_m.removeClass( 'current-menu-item' );
 		this.$lis_m.eq( i ).addClass( 'current-menu-item' );
 	}

 	initMenuSticky( b ){
 		if ( this.options.sticky ){
 			if ( b ){

				ScrollTrigger.create({
					trigger: this.$el.find( '.anchor-menu.hide-for-mobile' ),
					start: "top top", // below header
					pin: true,
					pinSpacing: false,
					end: ()=>{ return $(document).height() - $(window).height() + 100 },
					scrub: true,
					markers: false,
					toggleClass: 'is-sticky',
					id: 'id-anchor-menu-sticky',
					onToggle: self =>{
						if( self.direction === 1 ){
							$( 'body' ).addClass( 'is-anchor-menu-sticky' );
						}
						else{
							$( 'body' ).removeClass( 'is-anchor-menu-sticky' );
						}
					}

				})

				ScrollTrigger.create({
					trigger: this.$el.find( '.anchor-menu.show-for-mobile' ),
					start: "top top+=110", // below header
					pin: true,
					pinSpacing: false,
					end: ()=>{ return $(document).height() - $(window).height() + 100 },
					scrub: true,
					markers: false,
					toggleClass: 'is-sticky',
					id: 'id-anchor-menu-mobile-sticky',
					onToggle: self =>{
						if( self.direction === 1 ){
							$( 'body' ).addClass( 'is-anchor-menu-mobile-sticky' );
						}
						else{
							$( 'body' ).removeClass( 'is-anchor-menu-mobile-sticky' );
						}
					}

				})

 			}
 			else{

 				$( 'body' ).removeClass( 'is-anchor-menu-mobile-sticky' );
 				ScrollTrigger.getById( 'id-anchor-menu-mobile-sticky' ).kill();
 			
 			}
 		}
 	}

 	initSectionsRevealIndex(b){
 		let $el;
		this.$sections.each( (i, el)=>{
			$el = $(el);
			if ( i < this.$sections.length ){
				if ( b ){
					ScrollTrigger.create({
						trigger: $el,
						start: "top center-=200px", // below header
						end: "bottom center+=200px",
						scrub: true,
						markers: false,
						id: 'id-anchor-section-' + i,
						onEnter: self =>{
							//console.log( 'onEnter' );
							//console.log( self );
							$el = $(self.trigger);
							this.setIndex( $el.attr( 'data-index' ) );
						},
						onEnterBack: self =>{
							//console.log( 'onEnterBack' );
							$el = $(self.trigger);
							this.setIndex( $el.attr( 'data-index' ) );
						}
						/*
						onLeave: self =>{
							console.log( 'onLeave' );
							//console.log( self );
						}
						*/

					})
				}
				else{
					ScrollTrigger.getById( 'id-anchor-section-' + i ).kill();
				}
			}
		})
 	}


    //---------------------------------------- METHODS ---------------------------------------//
    destroy(){
		if ( this.$el.length > 0 ){
    		this.addEvents( false );
    	}
    }

}
